<template>
  <div class="modal">
    <div class="modal__section">
      <div class="modal__title modal__section-title">Статус заявки:</div>
      <el-select v-model="status">
        <el-option
          v-for="item in statuses"
          :key="item.code"
          :label="item.title"
          :value="item.code"
          class="modal__section-checkbox"
        />
      </el-select>
    </div>
    <div>
      <div class="modal__title">Комментарий к заявке:</div>
      <el-input
        v-model="comment"
        type="textarea"
        :rows="4"
        resize="none"
        maxlength="400"
        show-word-limit
        placeholder="Введите комментарий"
        :class="{ error: hasError }"
        @focus="clearValidate"
      />
      <el-collapse-transition>
        <div v-if="hasError" class="modal__error">
          При переводе в статус "Отклонена" комментарий обязателен!
        </div>
      </el-collapse-transition>
    </div>
    <div class="modal__buttons">
      <el-button
        type="info"
        class="modal__buttons-item"
        @click="$emit('close')"
      >
        Отмена
      </el-button>
      <el-button type="danger" class="modal__buttons-item" @click="submitForm">
        Сохранить
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BidEditModal',
  props: {
    bid: {
      type: Object,
      default: () => ({}),
    },
    statuses: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      comment: '',
      status: '',
      hasError: false,
    }
  },
  mounted() {
    this.comment = this.bid.comment
    this.status = this.bid.status_code
  },
  methods: {
    submitForm() {
      // для статуса "Отклонена" комментарий обязателен
      if (this.status === 'rejected' && !this.comment) {
        this.hasError = true
      } else {
        this.$emit('update', { status: this.status, comment: this.comment })
      }
    },
    clearValidate() {
      this.hasError = false
    },
  },
}
</script>

<style lang="sass" scoped>
.modal
  display: flex
  flex-direction: column
  gap: 40px
  &__title
    font-size: 16px
    font-weight: bold
  &__section
    display: flex
    align-items: center
    &-title
      width: 200px
    &-checkbox
      flex: 1

  .el-textarea
    ::v-deep .el-textarea__inner
      word-break: break-word

  .el-textarea.error
    ::v-deep .el-textarea__inner
      border: 1px solid #f56c6c

  &__error
    margin-left: 15px
    font-size: 12px
    font-weight: bold
    color: #f56c6c

  &__buttons
    align-self: center
    display: flex
    gap: 30px

    &-item
      width: 150px
</style>
